const findParent = ( $el, componentName ) => {
  while ($el) {
    if ($el.$vnode.componentOptions.tag === componentName) return $el;
    $el = $el.$parent;
  }
  return null;
};

const getModal = ( $el ) => findParent($el, 'modal');

export default {
  methods: {
    modalResolve( data ) {
      const modal = getModal(this);
      if (!modal) return console.warn('Модальное окно не найдено');
      modal.resolve(data);
    },
    modalReject( data ) {
      const modal = getModal(this);
      if (!modal) return console.warn('Модальное окно не найдено');
      modal.reject(data);
    },
    modalBeforeClose( cb ) {
      const modal = getModal(this);
      if (!modal) return console.warn('Модальное окно не найдено');
      modal.onBeforeClose(cb);
    },
  },
};
